<template>
  <div class="details">
    <PageHeader
      title="售客/客源详情"
      :userInfo="userInfo"
      :uidObj="uidObj"
      :AManager="AManager"
      @openClaimModal="openClaimModal"
      @transferValid="getEditHouseInfoStatus"
      @updateTourisDishTypePrivateToCompany="updateTourisDishTypePrivateToCompany"
      @isWatchFn="isWatchFn"
      @editBtn="editBtn"
      @toFollow="toFollow"
      @setFive="setFive"
      @setGood="setGood"
      @openMainTainerModal="openMainTainerModal"
      @openSuspendModal="openSuspendModal"
      @synchronizationFn="synchronizationFn"
    />

    <!-- tabs -->
    <PageTabs
      type="sale"
      :activeKey="activeKey"
      :aboutPerson="aboutPerson"
      :botList="botList"
      :curLook="curLook"
      :curtId="curtId"
      :form="form"
      :isShow="isShow"
      :loading="loading"
      :personList="personList"
      :personTotal="personTotal"
      :query="query"
      :recordList="recordList"
      :records="records"
      :shopListTitle="shopListTitle"
      :shopPagination="shopPagination"
      :total="total"
      :uidObj="uidObj"
      :userInfo="userInfo"
      :personTypeList="personTypeList"
      :rentSaleType="2"
      @setIntentionFn="setIntentionFn"
      @toFollow="toFollow"
      @openLookModal="openLookModal"
      @openInterviewModal="openInterviewModal"
      @upStatus="upStatus"
      @handleGohouse="handleGohouse"
      @handledownload="handledownload"
      @pageChange="pageChange"
      @personChange="personChange"
      @onChange="onChange"
      @onekeyPush="onekeyPush"
      @handleSort="handleSort"
      @changeTabs="changeTabs"
    />
    <a-tabs default-active-key="1" :forceRender="true" @change="changeTabs" v-if="false">
      <a-tab-pane key="1" tab="基本信息">
        <div class="top">
          <div class="left">
            <div class="one">
              <p style="font-size: 50px" v-if="userInfo.lesseeInfoVo">
                {{ userInfo.lesseeInfoVo.lesseeName.charAt(0) }}
              </p>
              <p v-if="userInfo.lesseeInfoVo" class="num">{{ userInfo.lesseeInfoVo.lesseeCode }}</p>
            </div>
            <div class="two">
              <span class="name" v-if="userInfo.lesseeInfoVo">{{ userInfo.lesseeInfoVo.lesseeName }}</span>
              <span
                class="label"
                :class="{ 'label-active': userInfo.identityWill === 'Y' }"
                @click="setIntentionFn"
                v-if="userInfo.accendantId === uidObj.userId"
              >意向</span
              >
              <div style="margin-top: 10px">
                <a-tag color="pink" v-if="userInfo.identityFive === 'Y'"> 五 </a-tag>
                <a-tag color="green" v-if="userInfo.identityExcellent === 'Y'"> 优 </a-tag>
              </div>
            </div>
          </div>
          <div class="right"></div>
        </div>
        <a-divider />
        <h3 class="demand">需求</h3>
        <sell-demand-content :userInfo="userInfo"></sell-demand-content>
        <a-divider />
        <h3 class="demand">备注</h3>
        <p style="height: 100px">{{ userInfo.otherInfo ? userInfo.otherInfo : '暂时没有备注信息' }}</p>
        <!-- 底部动态 -->
        <div class="bot-detail">
          <a-row>
            <a-col :span="12">
              <p>动态</p>
              <div class="child" v-if="userInfo.accendantId === uidObj.userId">
                <span class="iconfont icon-bianji1" style="font-size: 20px; color: var(--ThemeColor)"></span>
                <span @click="isFollow = true" style="cursor: pointer">写跟进</span>
                <span @click="isLook = true" style="cursor: pointer">录带看</span>
                <span @click="isInterview = true" style="cursor: pointer">录面访</span>
              </div>
            </a-col>
            <a-col :span="12">
              <p>相关人员</p>
              <!-- <span class="iconfont icon-bianji1" style="font-size: 20px; color: var(--ThemeColor)"></span>
              <span>编辑人员</span> -->
            </a-col>
          </a-row>
          <div class="bot-detail-bot">
            <!-- 动态列表 -->
            <div class="bot-detail-left">
              <div class="bot-detail-left-center">
                <ul class="bot-detail-left-center-ul" v-if="botList">
                  <li
                    style="cursor: pointer"
                    v-for="item in botList"
                    :key="item.dictValue"
                    :class="{ show: curtId == item.dictValue }"
                    @click="upStatus(item.dictValue)"
                  >
                    {{ item.dictLabel }}
                  </li>
                </ul>
                <div class="child-bot" v-if="recordList">
                  <div v-for="item in recordList" :key="item.id">
                    <div class="child-bot-left">
                      <div class="child-bot-left-por">
                        {{
                          item.recordType == 1
                            ? '面访'
                            : item.recordType == 2
                              ? '跟进'
                              : item.recordType == 3
                                ? '查看'
                                : item.recordType == 4
                                  ? '被带看'
                                  : item.recordType == 5
                                    ? '钥匙'
                                    : item.recordType == 6
                                      ? '其他'
                                      : item.recordType == 8
                                        ? '意向'
                                        : '带看'
                        }}
                      </div>
                      <div class="child-bot-left-name">
                        <p class="name">
                          {{
                            item.createByName.length > 7 ? item.createByName.substr(0, 7) + '...' : item.createByName
                          }}
                        </p>

                        <p class="desc" v-if="item.houseInfoSaleVoList" style="display: flex; flex-wrap: wrap">
                          {{ item.recordType === '7' ? '带看了房源' : item.recordContent || '' }}
                          <span
                            v-for="(v, i) in item.houseInfoSaleVoList"
                            :key="v.id"
                            @click="handleGohouse(v)"
                            class="houseCode"
                          >
                            <!-- {{ v.houseCode.substr(0, 7) }} -->
                            {{ v.shopName }}
                            <span v-if="!(item.houseInfoSaleVoList.length - 1 === i)">、</span>
                          </span>
                        </p>
                        <p class="desc" v-else>{{ item.recordContent }}</p>
                      </div>
                    </div>

                    <div class="child-bot-right">
                      <p class="time">{{ item.createTime }}</p>
                      <p
                        v-if="item.recordType == 1"
                        class="time downLoad"
                        @click="handledownload(item.accessoryFileList)"
                      >
                        下载附件
                      </p>
                    </div>
                  </div>
                </div>
                <!-- 动态列表分页 -->

                <a-pagination
                  style="text-align: right"
                  v-if="total"
                  size="big"
                  :pageSize="query.pageSize"
                  :current="query.pageNum"
                  :showTotal="(total) => `共 ${total} 条`"
                  :total="total"
                  @change="pageChange"
                />
                <div v-else>
                  <no-data></no-data>
                </div>
              </div>
            </div>
            <!-- 相关人员 -->
            <div class="bot-detail-right">
              <div class="right-center">
                <a-row style="display: flex; align-items: center" v-for="item in personList" :key="item.id">
                  <a-col :span="4">
                    <a-avatar v-if="item.avatar" :size="64" icon="user" :src="item.avatar" />
                    <a-avatar v-else :size="64" icon="user" :src="imgUrlpor" />
                  </a-col>
                  <a-col :span="20">
                    <p>
                      {{ item.relatedDeptName }}.
                      {{
                        item.relatedPersonnelName.length > 7
                          ? item.relatedPersonnelName.substr(0, 7) + '...'
                          : item.relatedPersonnelName
                      }}
                    </p>
                    <p>
                      {{ personType(item.relatedPersonnelType, personTypeList) }}
                      <span>{{ item.createTime }}</span>
                    </p>
                  </a-col>
                </a-row>
              </div>
              <!-- 分页 -->

              <a-pagination
                style="text-align: right"
                v-if="personTotal"
                size="big"
                :showTotal="(total) => `共 ${total} 条`"
                :pageSize="aboutPerson.pageSize"
                :current="aboutPerson.pageNum"
                :total="personTotal"
                @change="personChange"
              />
              <div v-else>
                <no-data></no-data>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" tab="店铺推荐" force-render>
        <sell-demand-content :userInfo="userInfo"></sell-demand-content>
        <a-divider />
        <div class="btn-box">
          <button class="btn" @click="onekeyPush">一键推铺</button>
        </div>
        <div class="shoplist-title" v-show="records.length">
          <div></div>
          <div></div>
          <div v-for="(v, i) in shopListTitle" :key="v">
            <div class="title-item" @click="handleSort(i)">
              <span :class="{ cur: curLook[i] }">{{ v }} </span>
              <div class="icon">
                <a-icon type="caret-up" :class="{ cur: curLook[i] && form.sortType == 'ASC' }" />
                <a-icon type="caret-down" :class="{ cur: curLook[i] && form.sortType == 'DESC' }" />
              </div>
            </div>
          </div>
        </div>
        <a-divider v-show="records.length" />
        <a-spin :spinning="loading">
          <houseSellList :records="records"></houseSellList>
        </a-spin>
        <div v-show="isShow">
          <a-pagination
            v-if="records.length"
            :current="form.pageNum"
            :page-size="form.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            :total="shopPagination.total"
            @change="onChange"
            class="dateli"
          />
          <div v-else>
            <no-data></no-data>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="4" tab="自定义推铺" force-render>
        <searchForm pageName="sellDetail"></searchForm>
      </a-tab-pane>
      <a-tab-pane key="3" tab="历史成交" v-if="isHistory">
        <a-table
          :rowKey="
            (record, index) => {
              return index
            }
          "
          :columns="columns"
          :loading="tableLoading"
          :pagination="pagination"
          @change="handleChangeInTable"
          :data-source="transactionHistoryList"
          :customRow="getContractDetail"
        >
          <a slot="name" slot-scope="text">{{ text }}</a>
          <template slot="contractCode" slot-scope="contractCode">
            <h1 style="color: var(--ThemeColor)">{{ contractCode }}</h1>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <!-- 公客认领弹屏 -->
    <claim-tk
      :visible="isClaim"
      @closeTK="claimOK"
      :isOpenReceiveAudit="userInfo.isOpenReceiveAudit"
      receiveType="2"
      :resourceId="Number(this.$route.query.id)"
      rentSaleType="2"
    ></claim-tk>
    <!-- 写跟进 弹屏 -->
    <follow-up
      :isFollow="isFollow"
      :resourceId="Number(this.$route.query.id)"
      resourceType="2"
      rentSaleType="2"
      @closeModal="isFollow = $event"
      @refresh="refresh"
    ></follow-up>

    <!-- 查看 -->
    <modal-check ref="modalCheck" :iscloseBtn="iscloseBtn" :watchInfo="watchInfo" />

    <!-- 录面访 弹屏 -->
    <modal-interview ref="ModalInterview" :userId="userId" @onSuccess="getRecordList" />

    <!-- 录带看   弹屏 -->
    <modal-look
      ref="ModalLook"
      type="sale"
      :houseInfoList="houseInfoList"
      :userId="userId"
      @delItem="delItem"
      @getListData="getListData"
      @resetFile="resetFileLook"
      @onSuccess="successLook"
    />

    <!-- 意向   弹屏 -->
    <modal-Intention
      ref="ModalIntention"
      type="sale"
      :houseInfoList="houseInfoList"
      @delItem="delItem"
      @getListData="getListData"
      @resetFile="resetFileLook"
      @onSuccess="successLook"
    />

    <!-- 跟多-转维护人 弹屏 -->
    <ModalMainTainer ref="ModalMainTainer" type="sale" :userList="userList" @onSuccess="toMaintainSuccess" />

    <!-- 跟多-暂缓 弹屏 -->
    <ModalSuspend ref="ModalSuspend" type="sale" :userInfo="userInfo" @onSuccess="successLook" />

  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import sell_touristApi from '@/api/system/tourist/sell_tourist.js'
import houseSellList from '@/components/houseList/houseSellList.vue'
import './resources/font/iconfont.css'
import FollowUp from '@/components/modal/FollowUp.vue'
import sellLookList from '@/components/modal/sellLookList.vue'
import ClaimTk from '@/components/modal/ClaimTK.vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import { contractsInfoList } from '@/api/system/contract'
import sellDemandContent from './cards/sellDemandContent.vue'
import houseApi, { userSeeRecord } from '@/api/system/houses/house.js'
import { mapGetters } from 'vuex'
import { treeSelectMixin } from '@/mixin/treeSelect'
import SearchForm from './cards/searchForm.vue'
// 头部
import PageHeader from './components/detail/header.vue'
// tabs
import PageTabs from './components/detail/tabs.vue'
// 弹窗
import ModalCheck from './components/modal/modal-check.vue'
import ModalInterview from './components/modal/modal-interview.vue'
import ModalLook from './components/modal/modal-look.vue'
import ModalIntention from './components/modal/modal-intention.vue'
import ModalMainTainer from './components/modal/modal-main-tainer.vue'
import ModalSuspend from './components/modal/modal-suspend.vue'

// 表格数据
const columns = [
  {
    title: '合同',
    dataIndex: 'contractCode',
    key: '1',
    scopedSlots: {
      customRender: 'contractCode'
    }
  },
  {
    title: '品牌',
    dataIndex: 'lesseeBrandName',
    key: '2'
  },
  {
    title: '成交时间',
    dataIndex: 'signDate',
    key: '4',
    ellipsis: true
  },
  {
    title: '成交价格',
    dataIndex: 'rentExpense',
    key: '5',
    ellipsis: true
  },
  {
    title: '房佣',
    dataIndex: 'lessorComm',
    key: '6',
    ellipsis: true
  },
  {
    title: '客佣',
    dataIndex: 'lesseeComm',
    key: '7',
    ellipsis: true
  }
]
let route = {}
export default {
  name: 'TouristSellDetails',
  components: {
    houseSellList,
    FollowUp,
    sellLookList,
    ClaimTk,
    sellDemandContent,
    SearchForm,
    PageHeader,
    PageTabs,
    ModalCheck,
    ModalInterview,
    ModalLook,
    ModalIntention,
    ModalMainTainer,
    ModalSuspend
    },
  mixins: [treeSelectMixin],

  data () {
     const userInfo = this.$getters.userInfo
    const isHistory = userInfo.data.permissions.includes('houses:houseInfo:makeHistory') || userInfo.data.permissions.includes('*:*:*')
    return {
      isHistory,
      iscloseBtn: false, // 查看框的关闭按钮
      isIntention: false, // 意向
      AManager: false, // A店长的权限
      uidObj: this.$getters.userInfo,
      imgUrlpor: require('@/assets/home-imgs/头像.svg'),
      userId: Number(this.$route.query.id), // 来源id
      userInfo: {},
      recordList: [],
      houseInfoVoList: [], // 带看房源列表
      // 动态列表请求参数
      query: {
        pageNum: 1,
        pageSize: 10,
        isAsc: '', // 排序的方向
        orderByColumn: '', // 排序列
        recordType: '', // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他
        requirementId: Number(this.$route.query.id),
        rentSaleType: '2' // 租售类型rent_sale_type  1租2售
      },
      // 成交历史表格数据
      transactionHistoryList: [],
      columns,
      tableLoading: false,
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      // 上传附件
      // uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      // headers: {
      //   Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
      // },
      // ossid: [],

      // 新增面访记录参数
      interviewRecordData: {
        accessoryIds: '', // 附件IDs
        interviewContent: '', // 面访内容
        interviewTime: '', // 面访时间
        resourceId: this.userId,
        resourceType: '2',
        rentSaleType: '2'
      },
      // 新增带看记录参数
      // takeLookRecordData: {
      //   houseId: [], //	房源ids
      //   resourceId: this.userId, // 来源ID
      //   takeLookContent: '', // 带看内容
      //   takeLookTime: '', // 带看时间
      //   rentSaleType: '2'
      // },
      // 点亮意向参数
      identityStrData: {
        houseId: [], //	房源ids
        id: 0, // 来源ID
        identityStr: 'Y'
      },
      // 转维护人接口参数
      // maintainer: {
      //   accendantId: undefined,
      //   deptId: undefined,
      //   id: this.$route.query.id
      // },
      // 相关人员-参数
      aboutPerson: {
        pageNum: 1,
        pageSize: 10,
        resourceId: 0,
        resourceType: '2', // (房源1，客源2)
        isAsc: '',
        orderByColumn: '',
        rentSaleType: '2'
      },
      // 相关人员-数据
      personList: [],
      personTypeList: [],
      personTotal: 0,
      // 部门人员
      dept: [],
      userList: [],

      visible: false,
      botList: [
      ],
      curtId: 0,
      // 店铺推荐
      loading: false,
      shopListTitle: ['单价', '售价', '面积', '盘别'],
      isShow: false,
      records: [],
      // 一键推铺
      form: {
        hourseSort: 1, // 房源排序（1：默认 2：租金(元/月) 3：租金(元/平方米/月) 4：带看 5：面积 6：盘别） 7：售价 8：单价
        houseResourceType: 1,
        pageNum: 1,
        pageSize: 10,
        sortType: 'ASC', // 排序规则 ASC / DESC
        endRentFee: '',
        startRentFee: '',
        houseStatus: '1'// 房源状态 字典表类型：house_status
        // businessDistrictId: '', //商圈id
        // industryCategoryId: '', //行业分类ID
        // industrySubclassId: '', //经营行业ID
        // startRentFee: '', //价格
        // endRentFee: '',
        // startHouseFloor: '', //楼层
        // endHouseFloor: '',
        // startAcreage: '', //面积
        // endAcreage: '',
        // houseStatus: '', //1有效,
      },
      shopPagination: {
        total: 0
      },
      curLook: [false, false, false, false],

      // 分页数据
      total: 0, // 总条数

      // 是否弹窗
      isClaim: false,
      isWatch: false,
      watchInfo: {},
      isFollow: false,
      // isInterview: false,
      // isLook: false,
      // isLookList: false,
      houseInfoList: [], // 录带看房源列表选择后的数组
      // isMaintainer: false,
      // isSuspend: false,
      isScroll: false, // 带看弹窗是否滚动
      // 修改暂缓-参数
      // suspend: {
      //   id: this.$route.query.id,
      //   identity: '6', // 标识（1：五，3：优，5:意向，6:暂缓）
      //   identityStr: 'Y',
      //   suspendedReason: ''
      // },

      imgUrl: '', // 上传
      activeKey: '1',
      countReq: 0
    }
  },
  methods: {
    init () {
      if (this.countReq > 1) {
        return
      }
      this.query.requirementId = Number(this.$route.query.id)
      if (!this.$getters.userInfo.data.roles.includes('ZJL')) {
            this.goFollowUpBtn() // 防止查看后刷新
      }

        this.DICT() // 字典表函数
        this.getUserInfo()
        this.getRecordList()
        this.getDeptList()
        this.getPersonList()
        this.countReq = 0
    },
    // 查看弹窗-去跟进弹窗
    goFollowUpBtn () {
      userSeeRecord().then((res) => {
        if (res.code === 200) {
          this.isWatch = false
          this.$store.commit('SET_IS_FOLLOWUP_OBJ', res.data)
        }
      })
    },
        // 修改客源状态
    getEditHouseInfoStatus (type) {
      const parmars = {}
      parmars.lastStatus = type
      parmars.resourceId = this.$route.query.id
      parmars.rentSaleType = '2'
      parmars.resourceType = '2'
      parmars.lastStatusName = type == '1' ? '有效' : '无效'
      houseApi.editHouseInfoStatus(parmars).then((res) => {
        if (res.code === 200) {
          this.getUserInfo()
            this.$message.success(`转为${type == '1' ? '有效' : '无效'}成功`)
        }
      })
    },
    judgePermission () {
      const info = (this.$store.state.user.info && this.$store.state.user.info.data.leaders) || []
      const jurisdiction = info.map(item => item.deptId).includes(this.userInfo.accendantStoreId)
      this.AManager = jurisdiction || this.getAdmin
      console.log(info, jurisdiction, 'A店长')
    },
  // 拥有LZXG权限的管理人员 可以把离职人员的 私客转为公客
    updateTourisDishTypePrivateToCompany () {
      touristApi.updateSellDishTypePrivateToCompany(this.$route.query.id).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.getUserInfo()
        }
      })
    },
    // 设置意向点亮或取消
    setIntentionFn () {
      if (this.userInfo.identityWill === 'Y') {
        this.identityStrData.identityStr = 'N'
        this.identityStrData.houseId = this.userInfo.willHouse
        this.identityStrData.id = this.userId

        sell_touristApi.identityWill({ ...this.identityStrData }).then((res) => {
          if (res.code === 200) {
            this.$message.success('已取消点亮')
            this.getUserInfo()
            this.getRecordList()
            this.closeIntentionFn()
          }
        })
      } else {
        // this.isIntention = true
        this.$refs.ModalIntention.open()
      }
    },

    // 关闭意向弹窗
    closeIntentionFn () {
      this.houseInfoList = []
      this.identityStrData.houseId = []
      // this.isIntention = false
    },
    // 一键同步
    async synchronizationFn () {
      const res = await sell_touristApi.synchronization({
        id: this.userId,
        rentSaleType: '2',
        channelResource: 1
      })
      if (res.code === 200) {
        this.$message.success('已成功同步至租客')
      }
    },
    // 打开暂缓弹窗
    openSuspendModal () {
      this.$refs.ModalSuspend.open()
    },
    // 切换tab选项
    changeTabs (tab) {
      // if (tab == 2) {
      //   // this.getHouseList()
      // } else if (tab == 3) {
      //   this.getTransactionHistoryList()
      // }
      this.activeKey = tab
    },

    // 成交历史-----------------
    getTransactionHistoryList () {
      const params = {
        requirementId: this.$route.query.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        contractType: '2'
      }
      this.tableLoading = true
      contractsInfoList(params).then(({ code, data }) => {
        this.tableLoading = false
        if (code === 200) {
          this.transactionHistoryList = data.records
          this.pagination.total = data.total
        }
      })
    },
    // 历史成交分页
    handleChangeInTable (pagination, filters, sorter) {
      // 分页、排序、筛选变化时触发
      this.pagination = pagination
      this.getTransactionHistoryList()
    },
    getContractDetail: function (record, index) {
      return {
        on: {
          click: () => {
            this.$router.push({
              path: '/contract/details',
              query: { id: record.id }
            })
          }
        }
      }
    },

    // 下载附件
    handledownload (list) {
      const url = list[0].url
      var a = document.createElement('a') // 创建一个a节点插入的document
      var event = new MouseEvent('click') // 模拟鼠标click点击事件
      a.download = 'file' // 设置a节点的download属性值
      a.href = url // 将图片的src赋值给a节点的href
      a.dispatchEvent(event)
    },

    // 获取客户数据
    getUserInfo () {
      sell_touristApi.touristDetails(this.$route.query.id).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data
          console.log(this.userInfo)
          this.judgePermission()
          // this.form.businessDistrictId = res.data.businessDistrictId ? res.data.businessDistrictId : ''
          // this.form.industryCategoryId = res.data.industryCategoryId ? res.data.industryCategoryId : ''
          // this.form.industrySubclassId = res.data.industrySubclassId ? res.data.industrySubclassId : ''
          this.form.startRentFee = res.data.rentExpenseStart ? res.data.rentExpenseStart : ''
          this.form.endRentFee = res.data.rentExpenseEnd ? res.data.rentExpenseEnd : ''
          // this.form.startHouseFloor = res.data.floorStart ? res.data.floorStart : ''
          // this.form.endHouseFloor = res.data.floorEnd ? res.data.floorEnd : ''
          // this.form.startAcreage = res.data.requirementAreaStart ? res.data.requirementAreaStart : ''
          // this.form.endAcreage = res.data.requirementAreaEnd ? res.data.requirementAreaEnd : ''
        }
        this.getRecordList()
        this.getPersonList()
      })
    },
    // 返回
    reback () {
      this.$router.go(-1)
    },

    // 获取客源动态记录列表
    getRecordList () {
      if (this.query.recordType == 0) {
        this.query.recordType = ''
        touristApi.getRecordList({ ...this.query }).then((res) => {
          if (res.code === 200) {
            this.recordList = res.data.records
            this.total = res.data.total
          }
        })
      } else {
        touristApi.getRecordList({ ...this.query }).then((res) => {
          if (res.code === 200) {
            this.recordList = res.data.records
            this.total = res.data.total
          }
        })
      }
    },

    // 去房源详情
    handleGohouse (item) {
      this.$router.push({
        path: '/houses/detail/sell',
        query: {
          id: item.id
        }
      })
    },

    // 切换动态记录列表
    upStatus (dictSort) {
      this.curtId = dictSort
      this.query.recordType = dictSort.toString()
      this.getRecordList()
    },
    // 相关人员
    getPersonList () {
      this.aboutPerson.resourceId = this.userId
      touristApi.personList({ ...this.aboutPerson }).then((res) => {
        if (res.code === 200) {
          // console.log('相关人员', res)
          this.personList = res.data.records
          this.personTotal = res.data.total
        }
      })
    },
    personChange (page, pageSize) {
      this.aboutPerson.pageNum = page
      this.aboutPerson.pageSize = pageSize
      this.getPersonList()
    },
    // 转维护成功
    toMaintainSuccess () {
      this.getUserInfo()
      this.getPersonList()
    },
    // 切换分页
    pageChange (page, pageSize) {
      this.query.pageNum = page
      this.query.pageSize = pageSize
      this.getRecordList()
    },
    // 打开录面访弹窗
    openInterviewModal () {
      this.$refs.ModalInterview.open()
    },

    // 带看提交成功
    successLook () {
      this.getRecordList()
      this.getUserInfo()
    },

     // 清楚数据
    resetFileLook () {
      this.houseInfoList = []
    },

    // 认领===>提交
    claimOK () {
      this.isClaim = false
      this.getUserInfo()
    },

    // 子组件（写跟进）提交，刷新父动态列表
    refresh () {
      this.getRecordList()
    },
    // 打开带看弹窗
    openLookModal () {
      this.$refs.ModalLook.open()
    },
    // // 面谈-上传
    // async handleChange (info) {
    //   if (info.file.status === 'done') {
    //     if (info.file.response.code !== 200) {
    //       this.$message.error('上传失败' + info.file.response.msg)
    //       return
    //     }
    //     this.ossid = info.fileList.map((item) => {
    //       return item.response.data.ossId
    //     })
    //     this.interviewRecordData.accessoryIds = this.ossid.toString()
    //     // console.log('ossidsd', this.interviewRecordData.accessoryIds)
    //   }
    //   if (info.file.status === 'removed') {
    //     this.ossid = info.fileList.map((item) => {
    //       return item.response.data.ossId
    //     })
    //     this.interviewRecordData.accessoryIds = this.ossid.toString()
    //     // console.log('ossidsd', this.interviewRecordData.accessoryIds)
    //   }
    // },
    disabledLookDate (current) {
      return current && current > this.$moment().endOf('day')
    },
    // 数组去重
    unique (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    // 获取子组件选择的对象
    getListData (data) {
      // console.log(data, '-----------------------')
      const arry = [...this.houseInfoList]
      arry.unshift(data)
      this.houseInfoList = this.unique(arry)
    },
    // 带看列表的删除按钮
    delItem (index) {
      this.houseInfoList.splice(index, 1)
    },

    // 设为五客
    setFive () {
      const params = {
        id: this.$route.query.id,
        identity: '1', // 标识（1:五，2:独，3:优，4:钥匙）
        identityStr: 'Y'
      }
      if (this.userInfo.identityFive === 'N') {
        sell_touristApi.editIdentity(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('设置五客成功')
            this.getUserInfo()
          }
        })
      } else {
        params.identityStr = 'N'
        sell_touristApi.editIdentity(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('已取消五客标识')
            this.getUserInfo()
          }
        })
      }
    },
    // 设为优客
    setGood () {
      const params = {
        id: this.$route.query.id,
        identity: '3', // 标识（1:五，2:独，3:优，4:钥匙）
        identityStr: 'Y'
      }
      if (this.userInfo.identityExcellent === 'N') {
        sell_touristApi.editIdentity(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('设置优质成功')
            this.getUserInfo()
          }
        })
      } else {
        params.identityStr = 'N'
        sell_touristApi.editIdentity(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('已取消优质标识')
            this.getUserInfo()
          }
        })
      }
    },

    // 获取部门列表
    getDeptList () {
      touristApi.getDeptList().then((res) => {
        if (res.code == 200) {
          // console.log('获取部门列表', res)
          this.dept = res.data.map((item) => {
            return {
              deptId: item.deptId,
              deptName: item.deptName
            }
          })
        }
      })
    },

    // 获取部门人员列表
    chooseDept (val) {
      touristApi.getUserList({ deptId: val }).then((res) => {
        if (res.code == 200) {
          this.userList = res.rows
          // console.log('获取部门人员列表', this.userList)
        }
      })
    },
    // 打开转维护弹窗
    openMainTainerModal () {
      this.$refs.ModalMainTainer.open()
    },
    // 查看
    isWatchFn () {
      this.getRequirement()
    },
    getRequirement () {
      const params = {
        id: Number(this.$route.query.id),
        rentSaleType: '2' // 1租2售
      }
      touristApi.getRequirement(params).then((res) => {
        if (res.code == 200) {
          this.watchInfo = res.data
          this.getRecordList()
          userSeeRecord().then((res) => {
            if (res.code === 200) {
              if (res.data.isFollowUp === 'Y') {
                this.iscloseBtn = true
              } else {
                this.iscloseBtn = false
              }
              this.$refs.modalCheck.open()
            }
          })
        }
      })
    },
    // 编辑
    editBtn () {
      const that = this
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'edit' }))
      this.$router.push({
        path: '/tourist/sellAdd',
        query: {
          id: that.$route.query.id
        }
      })
    },
    // 打开认领弹窗
    openClaimModal () {
      this.isClaim = true
    },
    // 打开写跟进弹窗
    toFollow () {
      this.isFollow = true
    },
    // 获取相关人员类型
    personType (val, list) {
      if (!val) return
      for (const d of list) {
        if (d.dictValue == val) {
          return d.dictLabel
        }
      }
    },
    // 字典表函数
    DICT () {
      this.getDicts('record_type').then((response) => {
        // console.log('字典类型record_type', response)
        // response.data.splice(3, 2) // 删除->被带看,钥匙
        // this.botList = [{ dictLabel: '全部', dictValue: 0 }, ...response.data]
        this.botList = [
          { dictLabel: '全部', dictValue: 0 },
          { dictLabel: '跟进', dictValue: 2 },
          { dictLabel: '面访', dictValue: 1 },
          { dictLabel: '查看', dictValue: 3 },
          { dictLabel: '带看', dictValue: 7 },
          { dictLabel: '意向', dictValue: 8 },
          { dictLabel: '其他', dictValue: 6 }
        ]
      })
      this.getDicts('related_personne_type').then((response) => {
        // console.log('related_personne_type', response.data)
        this.personTypeList = response.data
      })
      // this.getDicts('record_type').then((response) => {
      //   console.log('record_type', response.data)
      //   // this.rent_sale_type = response.data
      // })
    },
    // 店铺推荐----------------------------------------------
    // 一键推铺
    onekeyPush () {
      this.getHouseList()
      this.isShow = true
    },
    // 房源信息查询列表
    getHouseList () {
      this.loading = true

      sell_touristApi.gethouseInfoList(this.form).then((res) => {
        if (res.code === 200) {
          this.records = res.data.records
          this.shopPagination.total = res.data.total
          this.loading = false
        } else {
          this.$message.warning('房源信息获取失败')
          this.loading = false
        }
      })
    },
    onChange (current, pageSize) {
      this.form.pageNum = current
      this.form.pageSize = pageSize
      this.getHouseList()
    },
    // 筛选排序
    handleSort (index) {
      if (index === 0) {
        this.form.hourseSort = 8
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      } else if (index === 1) {
        this.form.hourseSort = 7
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      } else if (index === 2) {
        this.form.hourseSort = 5
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      } else {
        this.form.hourseSort = 6
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      }
    }

    // 历史合同--------------------------------------------
  },
  computed: {
    ...mapGetters(['isfollowUpObj']),
    // 拥有超级权限 ，
    getAdmin () {
      const arr = ['ZJL']
      const loginRole = this.$getters.userInfo.data.roles
      let status = false
      loginRole.forEach(el => {
        if (arr.includes(el)) {
          status = true
        }
      })
      return status
    }
  },
  activated () {
     const storage = sessionStorage.getItem('toDetail')
    const params = storage && JSON.parse(storage)
    if (params && params.fromPage) {
      this.activeKey = '1'
    }
    route = this.$route
     this.countReq++
    this.init()
  },
  deactivated () {
    sessionStorage.removeItem('toDetail')
  },
  created () {
    this.init()
  },
  watch: {
    houseInfoList () {
      if (this.houseInfoList && this.houseInfoList.length > 3) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    isfollowUpObj: {
      handler (valObj) {
        if (valObj && valObj.isFollowUp === 'N') {
          console.log(valObj, 'watch**********')
          if (!this.$getters.userInfo.data.roles.includes('ZJL')) {
            this.isFollow = true
          }
          // this.isFollow = true
        }
      },
      deep: true,
      immediate: true
    },
    '$route': {
      handler (val) {
        // console.log(val, '93893')
        if (this.$route.name === route.name) {
          // console.log(val, route,this.activeKey, '22', '0000999990000')
          // console.log(this.fromPageName,'54444',this.countReq)
          this.countReq++
          // this.init()
        }
      },
      deep: true
    }
  }
}
</script>

<style >
/* .ant-upload.ant-upload-select-picture-card {
  width: 240px;
  height: 160px;
} */
</style>

<style lang="less" scoped>
.details {
  background-color: #fff;
  padding: 20px;
  border-radius: 20px;
  //选项卡
  /deep/.ant-tabs-ink-bar {
    width: 0px !important;
  }
  /deep/.ant-tabs-tab-active {
    color: var(--ThemeColor);
    font-weight: 700;
  }
  /deep/.ant-tabs-tab {
    font-weight: 700;
  }
  .details-title {
    margin-bottom: 0px;
    font-weight: 700;
    font-size: 20px;
  }

  .bold {
    font-weight: bold;
    color: #000;
    font-size: 14px;
  }

  //店铺推荐

  .dateli {
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: right;
    margin-right: 30px;
  }

  //历史成交
  /deep/td:first-child > a {
    font-size: 20px;
  }
  /deep/.ant-table-header-column {
    font-weight: 700;
    color: #000;
  }
  // /deep/.ant-pagination {
  //   display: none;
  // }
}

.ant-divider-horizontal {
  margin: 10px 0;
}
</style>
